import React, { useState, useEffect, useRef } from "react";
import { FaNewspaper, FaPlay, FaSearch, FaBars } from "react-icons/fa";
import { signOut } from "firebase/auth";
import { auth } from "../firebase";
import { Link } from "react-router-dom";
import "./css/Navbar.css";
import ThemeSwitch from "./ThemeSwitch"; // adjust path if needed

const Navbar = ({ user, setShowAuthModal }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    // console.log("Navbar user:", user);
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [user]); // <-- add user here

  return (
    <nav className="navbar">
      <div className="navbar-inner">
        {/* Left: Logo and desktop links */}
        <div className="navbar-left">
          <Link to="/" className="navbar-logo">
            <img src="/logo.png" alt="GTAFanPage Logo" />
          </Link>

          {/* Desktop Navigation Links */}
          <div className="navbar-links desktop-links">
            <Link to="/trailers" className="nav-link">
              <FaPlay /> Trailers
            </Link>
            {/* <Link to="/blogs" className="nav-link">
              <FaNewspaper /> News / Blogs
            </Link> */}
            <Link to="/forum" className="nav-link">
              Community
            </Link>

          </div>
        </div>

        {/* Right: Auth + Hamburger */}
        <div className="navbar-right">
          {/* Theme Switch */}
          <div className="desktop-theme">
            <ThemeSwitch />
          </div>

          <div className="desktop-auth">
            {user ? (
              <div ref={dropdownRef} style={{ position: "relative" }}>
                <button
                  className="user-button"
                  onClick={() => setShowDropdown(!showDropdown)}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "transparent",
                    border: "none",
                    fontWeight: "bold",
                    cursor: "pointer",
                  }}
                >
                  {user.photoURL && (
                    <img
                      src={user.photoURL}
                      alt="Profile"
                      onError={(e) => (e.target.style.display = "none")} // hide broken images
                      style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        objectFit: "cover",
                      }}
                    />
                  )}
                  {user.displayName?.split(" ")[0] || "User"} ▼
                </button>

                {showDropdown && (
                  <div className="dropdown">
                    <Link
                      to="/profile"
                      className="dropdown-item"
                      onClick={() => setShowDropdown(false)}
                    >
                      Profile
                    </Link>

                    <div className="dropdown-divider" />
                    <button
                      onClick={() => signOut(auth)}
                      className="dropdown-item logout"
                    >
                      Logout
                    </button>
                  </div>
                )}
              </div>
            ) : (
              <button
                className="login-button"
                onClick={() => {
                  setShowAuthModal(true);
                  setShowDropdown(false);
                  setShowMenu(false);
                }}
              >
                Login / Signup
              </button>
            )}
          </div>

          <button className="hamburger" onClick={() => setShowMenu(!showMenu)}>
            <FaBars />
          </button>
        </div>

        {/* Mobile menu */}
        <div className={`navbar-links mobile-links ${showMenu ? "show" : ""}`}>
          <Link
            to="/trailers"
            className="nav-link"
            onClick={() => setShowMenu(false)}
          >
            <FaPlay /> Trailers
          </Link>
          <a
            href="#news"
            className="nav-link"
            onClick={() => setShowMenu(false)}
          >
            <FaNewspaper /> News
          </a>
          <a
            href="#leaks"
            className="nav-link"
            onClick={() => setShowMenu(false)}
          >
            <FaSearch /> Leaks
          </a>
          <Link
            to="/forum"
            className="nav-link nav-community"
            onClick={() => setShowMenu(false)}
          >
            Community
          </Link>
          {/* Mobile Theme Switch */}
          <div style={{ margin: "10px 0" }}>
            <ThemeSwitch />
          </div>

          <div className="mobile-auth">
            {user ? (
              <>
                <Link
                  to="/profile"
                  className="dropdown-item"
                  onClick={() => setShowDropdown(false)}
                >
                  Profile
                </Link>

                <div
                  className="dropdown-divider"
                  style={{ margin: "5px 0", borderTop: "1px solid #ddd" }}
                />
                <button
                  onClick={() => {
                    signOut(auth);
                    setShowMenu(false);
                  }}
                  className="nav-link logout"
                  style={{
                    color: "red",
                    background: "none",
                    border: "none",
                    padding: "10px",
                    textAlign: "left",
                    width: "100%",
                  }}
                >
                  Logout
                </button>
              </>
            ) : (
              <button
                className="login-button"
                onClick={() => {
                  setShowAuthModal(true);
                  setShowDropdown(false);
                  setShowMenu(false);
                }}
              >
                Login / Signup
              </button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
